import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'ca-chip',
  imports: [MatIcon],
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss',
})
export class ChipComponent {
  @Input() label: string = '';
  @Input() icon?: string;
  @Input() selected: boolean = false;
}
